import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { local420Api } from "../api/local420Api";
import { Season_Entity } from "../../entities/season";
import { Ids } from "../../reducers/rhapsody";

const seasonsAdapter = createEntityAdapter<Season_Entity>();
const initialState = seasonsAdapter.getInitialState();

export const seasonEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getSeasons: build.query<EntityState<Season_Entity>, void>({
      query: () => `seasons`,
      transformResponse: (responseData: Season_Entity[]) => {
        return seasonsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["seasons"],
    }),
    getSeason: build.query<Season_Entity, Ids>({
      query: (arg) => {
        return {
          url: `seasons/${arg.id}`,
          params: {
            sourceID: arg.sourceID,
            sourceRecordID: arg.sourceRecordID,
          },
        };
      },
      providesTags: ["seasons"],
    }),
    createSeason: build.mutation<Season_Entity, Partial<Season_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `seasons`,
      }),
      invalidatesTags: ["seasons"],
    }),
    updateSeason: build.mutation<
      void,
      { id: number; body: Partial<Season_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `seasons/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "seasons", id },
        "seasons",
      ],
    }),
    deleteSeason: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `seasons/${id}`,
      }),
      invalidatesTags: ["seasons"],
    }),
  }),
});

export const {
  useGetSeasonQuery,
  useGetSeasonsQuery,
  useCreateSeasonMutation,
  useDeleteSeasonMutation,
  useUpdateSeasonMutation,
} = seasonEndpoints;

export default seasonEndpoints;
